import React from "react";

const DownRightArrow = ({ iconClassName = "" }) => {
  return (
    <>
      <svg
        className={`block fill-none ${iconClassName}`}
        width="14"
        height="16"
        viewBox="0 0 14 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10.477 12.4108L8.56622 14.3216L9.74475 15.5001L13.6673 11.5774L9.74474 7.65485L8.56623 8.83336L10.477 10.7441L2.00065 10.744L2.00077 0.5H0.334104L0.333984 11.5773C0.333984 12.0375 0.707076 12.4106 1.16731 12.4106L10.477 12.4108Z"
          fill="#475467"
        />
      </svg>
    </>
  );
};

export default DownRightArrow;
